import { ScaffoldDetails } from './scaffold-details';
import { SiteDetails } from './site-details';
import { ScaffoldInspectionWebAppData } from './scaffold-inspection-web-app-data';
import { InspectionFollowUpInstructionData } from './inspection-follow-up-instruction-data';
import { InspectionFollowUpNotifyData } from './inspection-follow-up-notify-data';
import { UnsafeScaffoldReportData } from './unsafe-scaffold-report-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class InspectionActivityDetails {
  ActivityId: string;
  ScaffoldDetails: ScaffoldDetails;
  SiteDetails: SiteDetails;
  ActivityDateTime: string;
  RelativeInspectionId: string;
  ScaffoldInspections: ScaffoldInspectionWebAppData;
  InspectionFollowUpInstructions: InspectionFollowUpInstructionData;
  InspectionFollowUpNotifys: InspectionFollowUpNotifyData;
  UnsafeScaffoldReports: UnsafeScaffoldReportData;
}


